import React from 'react';
import heart_icon from '../../../../assets/images/heart_icon.png';

// Import a default placeholder image
import PuzzleIcon from '../../../../assets/images/PuzzleIcon';

const Wagmi = ({ data, campaign }) => {

    const { imageBuffer } = data;

    return (
        <div id='wagmi' className='default-settings'>
            {/* Title section with heart icon, dynamic text, and NFT icon */}
            <div className='wagmi__title-box'>
                {/* Heart icon for visual emphasis */}
                <img className="wagmi__title-heart-icon" src={heart_icon} alt="catdrop" />

                {/* Dynamic plus sign with color from wagmiData */}
                <h1 className="wagmi__title-text plus-sign" style={{ color: data.web_main_color }}>+</h1>

                {/* Conditionally render an NFT icon if available in imageBuffer, otherwise show default icon */}
                {imageBuffer?.ct_icon_nft ? (
                    // Convert binary data to base64 string for displaying SVG image
                    (() => {
                        const uint8Array = new Uint8Array(imageBuffer.ct_icon_nft.data);
                        let binaryString = '';
                        for (let i = 0; i < uint8Array.length; i++) {
                            binaryString += String.fromCharCode(uint8Array[i]);
                        }
                        return (
                            <img
                                src={`data:image/svg+xml;base64,${btoa(binaryString)}`}
                                className="topfund__title-icon"
                                alt="img"
                            />
                        );
                    })()
                ) : (
                    // Default image if no NFT icon data is provided
                    <PuzzleIcon
                        color={data.web_main_color}
                    />
                )}

                {/* Additional dynamic plus sign and 'U' character with color from wagmiData */}
                <h1 className="wagmi__title-text plus-sign" style={{ color: data.web_main_color }}>+</h1>
                <h1 className="wagmi__title-text" style={{ color: data.web_main_color }}>U</h1>
            </div>

            {/* Description text with dynamic color from wagmiData */}
            <p className="wagmi__desc" style={{ color: data.web_main_color }}>
                The purpose of the {campaign?.campaign_id ? data.nft_name_plural : "NFTs"} collection is to {data.purpose ? data.purpose : "raise money for individuals or non-governmental organizations selected by the artist and sponsor"}. If you would like to sponsor your own Fund Raisin campaign, or if you are an artist, please visit <a href='https://www.fundraisin.app' target='_blank'>https://www.fundraisin.app</a> to create your own.
            </p>
            <p className="wagmi__desc"  style={{ color: data.web_main_color }}>Fund Raisin, for any reason!</p>
        </div>
    );
};

export default Wagmi;
